/**
 * Validation of the `Import rules` form.
 *
 * The one rule this screen needs and the browser cannot express on its own: an empty required field is
 * not an error until the owner tries to move on. A freshly opened form must not look as though something
 * has already gone wrong, and the primary is never disabled - a dead button at the end of a multi-step
 * process says that something is missing without saying what.
 *
 * Which fields exist is read from the DOM rather than declared here: a group with no games in the
 * current selection renders no control at all, and a second list of field names would be a second answer
 * to that question.
 *
 * Without JavaScript the form submits as it is and the server refuses it with the same message - the
 * `novalidate` attribute is what makes that path reachable instead of a native bubble.
 */
import { initValidatedForm } from '../components/form-validation.js';

export function initSteamImportRules(documentRef = globalThis.document) {
    // Duck-typed rather than `instanceof HTMLFormElement`, like every other module on these screens:
    // this file is imported into a bundle that also loads where no document exists at all.
    const form = documentRef?.querySelector?.('[data-steam-import-rules-form]');
    if (typeof form?.querySelectorAll !== 'function') {
        return undefined;
    }

    const fields = [...form.querySelectorAll('select[required]')].map((select) => ({
        input: select,
        errorContainer: select.parentElement,
        errorClassName: 'ui-form-error',
        messages: {
            valueMissing: 'Choose a status for these games.',
        },
    }));

    if (fields.length === 0) {
        return undefined;
    }

    return initValidatedForm({ form, fields });
}

initSteamImportRules();
